import articleData from './articles.json';

export interface JournalSection {
  id: string;
  title: string;
  paragraphs?: string[];
  bullets?: string[];
  sources?: string[];
}
export interface JournalArticle {
  slug: string;
  title: string;
  seoTitle: string;
  category: string;
  image: string;
  imageAlt: string;
  description: string;
  date: string;
  intro: string;
  takeaway: string;
  sections: JournalSection[];
  prompt: string;
  sources: { id: string; title: string; url: string }[];
  related: string[];
  service: { label: string; path: string };
}
export const articles: JournalArticle[] = articleData;
export const journalName = 'Vaanii’s Journal';
export const journalDescription = 'Thoughtful guides to tarot, healing and everyday rituals. Explore practical prompts, the stories behind spiritual practices, and clearly sourced facts.';
export const articlePath = (article: JournalArticle) => `/journal/${article.slug}`;
export function readingMinutes(article: JournalArticle) {
  const text = [article.intro, article.takeaway, article.prompt, ...article.sections.flatMap(section => [section.title, ...(section.paragraphs || []), ...(section.bullets || [])])].join(' ');
  return Math.max(1, Math.ceil(text.split(/\s+/).length / 200));
}
export function journalDate(date: string) {
  return new Date(`${date}T12:00:00Z`).toLocaleDateString('en-IN', {day:'numeric',month:'long',year:'numeric',timeZone:'Asia/Kolkata'});
}
